export { MigrationsManagerEntryPoint } from './scope';
